import { useState, useMemo } from "react";
import { IconDownload, IconEye } from "@tabler/icons";
import { MyModal, Grid, Typography, Button, toast, Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper } from "./MyCustomFile";
import CircularProgress from "@mui/material/CircularProgress";
import ImportCommon from "views/commonFile/ImportCommon"
import UploadFileIcon from "@mui/icons-material/UploadFile";
import * as XLSX from "xlsx";
import DragDropCommon from "views/commonFile/DragDropCommon"
import ReadExcelFile from "views/commonFile/ReadExcelFile"
import { Badge, Box } from "@mui/material";
import { postAPI } from "../axios/api";

export const MyTitle = ({ typo, Add, setOpen, status = false, targetColumns, tableHeaders, tableNo = 0, fetchData, APIURL, industCheck = false }) => {
    // export const MyTitle = ({ typo, Add, setOpen, status = false, fetchData, APIURL }) => {
    const [show, setShow] = useState(false);
    const [loadingIs, setLoadingIs] = useState(false);
    const [showImg, setShowImg] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [items, setItems] = useState([]);
    const [oldDataArr, setOldDataArr] = useState([])
    const [unmatchedColumns, setUnmatchedColumns] = useState([]);
    const [tableHeaders1, setTableHeaders] = useState([]);
    const [showMsg, setShowMsg] = useState({ failureCount: 0, successCount: 0, checkList: [] });
    const [updatedItem, setUpdatedItem] = useState({ import_file: "", csvFile: "" });
    const [errorShow, setErrorShow] = useState(false);

    // Function to handle file reading (XLSX/CSV)
    const promise = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);
            fileReader.onload = (e) => {
                const bufferArray = e.target.result;
                const wb = XLSX.read(bufferArray, { type: "buffer" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws, industCheck ? { defval: "" } : { header: 1, defval: "" }); // Read header as first row
                resolve(data);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const readExcel = (file) => {
        setLoadingIs(true);
        setShowImg(false);
        promise(file)
            .then((data) => {
                if (industCheck) {
                    setOldDataArr(data)
                    ReadExcelFile(data, targetColumns, setItems, setUnmatchedColumns, setIsModalOpen, setShow)
                } else {
                    const [headerRow, ...rows] = data;
                    setTableHeaders(headerRow); // Set table headers dynamically from the file
                    setItems(rows); // Set table data excluding headers
                }
                setLoadingIs(false);
            })
            .catch((error) => {
                console.error("Error reading the file", error);
                setLoadingIs(false);
            });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setUpdatedItem({ import_file: file ? file.name : "", csvFile: file });
        if (file) {
            readExcel(file);
        }
    };

    const submitImportButton = async () => {
        try {
            const selectedFile = updatedItem.import_file;
            const fileExtension = selectedFile.split(".").pop().toLowerCase();
            if (fileExtension === "csv" || fileExtension === "xlsx") {
                let formData = {
                    csvFile: items,
                    fileExtension: fileExtension,
                };
                setLoadingIs(true);
                const { status, message, failureCount, successCount, checkList } = await postAPI(`${APIURL}/import`, formData);
                if (status) {
                    setShow(false);
                    setItems([]);
                    setShowImg(true);
                    fetchData();
                    setUpdatedItem({ import_file: "", csvFile: "" });
                    toast.success(message);
                } else {
                    toast.error(message);
                    setShowMsg({ failureCount, successCount, checkList });
                }
            } else {
                toast.error("Invalid file type. Please select a CSV or Excel file.");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingIs(false);
        }
    };

    // Export to Excel
    const exportToExcel = (data, fileName) => {
        // let dataStructure = data.map(({ error, ...rest }) => rest);
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    const columnFields = useMemo(() => {
        return {
            1: ["Association Name", "Association Type", "Association Branch", "Association Phone", "Country", "State", "City", "Pincode", "Error/Problem"],
            2: ["Industry Name", "Industry Type", "Country", "State", "City", "Pincode", "Error/Problem"],
            3: ["Firm Name", "Consultant Branch", "Consultant Phone", "Consultant Email", "Consultant Type", "Country", "State", "City", "Pincode", "Territory", "Error/Problem"],
            4: ["Prospect Name", "Prospect Branch", "Prospect Phone", "Nature Business", "Country", "State", "City", "Pincode", "Error/Problem"]
        };
    }, [])
    const rowFields = useMemo(() => {
        return {
            1: ["associationName", "associationType", "associationBranch", "associationPhone", "countryId", "stateId", "cityId", "pinCode", "error"],
            2: ["industryName", "industryType", "countryId", "stateId", "cityId", "pinCode", "error"],
            3: ["firmName", "consultantBranch", "consultantPhone", "consultantEmail", "consultantType", "countryId", "stateId", "cityId", "pinCode", "territory", "error"],
            4: ["prospectName", "prospectBranch", "prospectPhone", "natureBusiness", "countryId", "stateId", "cityId", "pinCode", "error"]
        };
    }, []);

    const closeModal = () => {
        setShow(false);
        setItems([]);
        setShowMsg({ failureCount: 0, successCount: 0, checkList: [] });
        setUpdatedItem({ import_file: "", csvFile: "" });
    };

    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h2">{typo}</Typography>
            <div>
                <Button variant="contained" title={Add} onClick={setOpen} style={{ marginBottom: 5 }}>{Add}</Button>
                {status && (
                    <Button variant="outlined" title="Import" onClick={() => setShow(true)} style={{ marginBottom: 5, marginLeft: 2 }}>
                        <IconDownload />
                    </Button>
                )}
            </div>

            <MyModal
                handleOpen={show}
                title={typo}
                size="lg"
                cancelReset
                handleClose={closeModal}
                extraButton={
                    <Box display="flex" justifyContent="center">
                        <Box display="flex" alignItems="center" mb={1}>
                            <Typography variant="body1" fontWeight="bold">Failure Count</Typography>
                            <Badge badgeContent={showMsg.failureCount || 0} color="info" sx={{ cursor: "pointer", ml: 2 }} onClick={() => { setErrorShow(true); setShow(false) }} />
                        </Box>
                        <Box display="flex" alignItems="center" ml={3}>
                            <Typography variant="body1" fontWeight="bold">Success Count</Typography>
                            <Badge badgeContent={showMsg.successCount || 0} color="info" sx={{ ml: 2 }} />
                        </Box>
                    </Box>
                }
                rows={
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <a download={`${APIURL}.csv`} href={`./assets/${APIURL}.csv`} className="ml-5" >Download Sample</a>
                        </Grid>
                        <Grid item xs={12}>
                            <input type="file" id="upload-file" style={{ display: "none" }} onChange={handleFileChange} accept=".csv, .xlsx" />
                            <label htmlFor="upload-file">
                                <Button variant="contained" component="span" startIcon={<UploadFileIcon />} color="primary">Import File</Button>
                            </label>
                            {updatedItem.import_file && <div>{updatedItem.import_file} {industCheck ? <IconEye style={{ cursor: "pointer" }} title="VIEW" onClick={() => { setIsModalOpen(true); setShow(false) }} /> : null} </div>}
                        </Grid>
                        <Grid item xs={12}>
                            {industCheck ? <ImportCommon
                                loadingIs={loadingIs}
                                showImg={showImg}
                                items={items}
                                tableHeaders={tableHeaders}
                                targetColumns={targetColumns}
                            /> : <TableContainer component={Paper}>
                                <Table size="small" aria-label="imported data table">
                                    <TableHead>
                                        <TableRow>
                                            {tableHeaders1.map((header, index) => (
                                                <TableCell key={index}><strong>{header}</strong></TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {items.map((row, rowIndex) => (
                                            <TableRow key={rowIndex}>
                                                {tableHeaders1.map((_, colIndex) => (
                                                    <TableCell key={colIndex}>{row[colIndex]}</TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>}
                        </Grid>
                    </Grid>
                } Save={items.length > 0 && (<Button variant="outlined" disabled={loadingIs} onClick={submitImportButton}>{loadingIs ? <CircularProgress color="secondary" /> : "Import"}</Button>)}
            />

            <MyModal handleOpen={errorShow} title={"Error Log"} size={"lg"} cancelReset={true} handleClose={() => { setErrorShow(false); setShow(true) }} rows={<Grid container>
                <Grid item md={12}>
                    <Button variant="outlined" title="Download file" onClick={() => exportToExcel(showMsg.checkList, typo)} style={{ marginBottom: 5, marginLeft: 2 }}> <IconDownload /> </Button>
                </Grid>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="error log table">
                        <TableHead>
                            <TableRow>
                                {columnFields[tableNo]?.map((e, i) => (<TableCell key={i}><strong>{e}</strong></TableCell>))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(showMsg.checkList) && showMsg.checkList.map((row, i) => (
                                <TableRow key={i}>
                                    {rowFields[tableNo]?.map((field, i) => (<TableCell key={i}>{row[field]}</TableCell>))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>} Save={""} />

            <DragDropCommon isModalOpen={isModalOpen} setItems={setItems} onHide={() => { setIsModalOpen(false); setShow(true); }} targetColumns={targetColumns} unmatchedColumns={unmatchedColumns} setUnmatchedColumns={setUnmatchedColumns} oldDataArr={oldDataArr} />

        </Grid>
    );
};